export default "__VITE_ASSET__1bd22233__"